import React, { useState } from 'react'
import cx from 'classnames'
import KeyboardArrowUp from '@material-ui/icons/KeyboardArrowUp'
import KeyboardArrowDown from '@material-ui/icons/KeyboardArrowDown'
import DocumentListing from './DocumentListing'

const Section = ({
  id: childId,
  title,
  documents: { documents = [] },
  startExpanded
}) => {
  const [expanded, setExpanded] = useState(startExpanded)
  const childDocuments = documents.filter(({ parentId }) => childId === parentId)

  const count = childDocuments.length

  return (
    <li
      className='bb b--precedents-blue list-item-reset'
      id={childId}
    >
      <div className={cx('hover-bg-precedents-blue-20 bg-precedents-blue-10', { 'bg-precedents-blue-exp': expanded })}>
        <a
          onClick={() => setExpanded(!expanded)}
          className='pointer'
          data-event-category='Precedents Automated'
          data-event-action={expanded ? 'Collapse' : 'Expand'} // based on where I stole this this should be flipped but I'm assuming that component is just janky
        >
          <div className={cx('flex justify-between pv6', { white: expanded })}>
            <div className={cx('b black f5 ml6', { white: expanded })}>
              {title}
            </div>
            <div className='mr6 flex'>
              <span className='mr6 no-select'> {count} </span>
              {expanded ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
            </div>
          </div>
        </a>
      </div>
      {count !== 0 && (
        <ul className={cx('list-reset pa0 bg-grey', { dn: !expanded })}>
          {
            childDocuments.map((doc, idx) => <DocumentListing key={doc.id} {...{ ...doc, isLast: idx === childDocuments.length - 1 }} />)
          }
        </ul>
      )}
      {count === 0 && (
        <ul className={cx('file-list list-reset pa0', { dn: !expanded })}>
          <li className='ma6 ml9'>
            <div className='info grey'>
              No files to show
            </div>
          </li>
        </ul>
      )}
    </li>
  )
}

export default Section
